import { Divider, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import { profileDataValidation, setItem } from "../../utils/Functions";
import { MultiSelect } from "react-selectize";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import {
  getQualificationDetails,
  getSkillSetList,
} from "../../pages/Profile/actions";
import ErrorMessage from "../../utils/ErrorMessage";
import SelectDropdown from "../SelectDropdown/SelectDropdown";
import moment from "moment-timezone";
import {
  ProfileCancelButton,
  ProfileEditButton,
  ProfileSaveButton,
} from "./ProfileButtons";
import { addSkillsMaster } from "../../pages/JobOpenings/action";
import MultiSelectComponent from "../Multiselect/MultiSelect";

const ProfessionalDetail = ({
  professionalDetails,
  showInput,
  handleShowInput,
  handleUpdate,
  isGuest,
  professionaldetails,
  setprofessionalDetails,
  errors,
  setErrors,
}) => {
  const dispatch = useDispatch();

  const qualificationDetailList = useSelector(
    (state) => state.profile.qualificationList
  );
  const loading = useSelector((state) => state.profile.loading);
  const { skillSetList } = useSelector((state) => state.profile);

  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [skillSetOptions, setSkillSetOptions] = useState([]);
  let typingTimer;
  useEffect(() => {
    dispatch(getQualificationDetails());
    dispatch(getSkillSetList());
  }, []);
  useEffect(() => {
    if (!isGuest) {
      const skillArray = [];
      professionalDetails?.skillSet?.map((skill) => {
        skillArray.push({ label: skill?.skill, value: skill?._id });
      });
      const date =
        professionalDetails?.expectedjoiningDate !== null &&
        professionalDetails?.expectedjoiningDate !== undefined
          ? new Date(professionalDetails?.expectedjoiningDate)
          : new Date();
      setprofessionalDetails({
        ...professionalDetails,
        // Map both key variants: update API uses 'totalExperiance', profile response uses 'totalExprience'
        totalExprience: professionalDetails?.totalExprience || professionalDetails?.totalExperiance || "",
        highestQualification: {
          label: professionalDetails?.highestQualification,
          value: professionalDetails?.highestQualification,
        },
        skillSet: skillArray,
        expectedjoiningDate: date,
      });
    }
  }, [professionalDetails]);

  useEffect(() => {
    if (skillSetList && skillSetList.length > 0) {
      const list = [];
      skillSetList?.map((item) => {
        return list.push({
          label: item?.skill,
          value: item?._id,
        });
      });

      if (skillSetList.length > 0) {
        setprofessionalDetails((prevDetails) => {
          const current = prevDetails?.skillSet || [];
          if (!current.length) {
            return prevDetails;
          }

          const selectedSkillList = current
            .filter((data) => data && data.label)
            .map((data) => {
              const match =
                list.find((dat) => dat.label === data.label) ||
                list.find(
                  (dat) =>
                    dat.label?.toLowerCase() === data.label?.toLowerCase()
                );
              // Keep CV/resume skill label if not in master yet
              return match || data;
            })
            .filter(
              (skill, index, arr) =>
                skill?.label &&
                arr.findIndex(
                  (s) =>
                    s.label?.toLowerCase() === skill.label?.toLowerCase()
                ) === index
            );

          return {
            ...prevDetails,
            skillSet: selectedSkillList,
          };
        });
      }
      setSkillSetOptions([
        ...list,
        {
          label: "",
          value: "",
        },
      ]);
    } else {
      setSkillSetOptions([]);
    }
  }, [skillSetList]);

  useEffect(() => {
    let qualificationArray = [];

    qualificationDetailList.length > 0 &&
      qualificationDetailList.map((qualification) =>
        qualificationArray.push({
          label: qualification.qualification,
          value: qualification._id,
        })
      );

    setQualificationOptions(qualificationArray);
  }, [qualificationDetailList]);
  return (
    <>
      <div className={`panel-header pt-0 ${isGuest ? "sec-head" : ""}`} id="section-professional">
        {isGuest && <div className="sec-num">2</div>}
        <div className="title">Professional Details</div>
      </div>
      <div className="panel-content py-0">
        <Row>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-highestQualification">
                <label className="form-label">
                  Highest Qualification held
                  <span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.qualification && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(
                        professionaldetails?.highestQualification?.label
                      )}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("qualification");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.qualification) && (
                  <div className="edit-inline-action">
                    <SelectDropdown
                      placeholder="Select qualification"
                      options={qualificationOptions}
                      // Controlled so CV auto-fill (educations.degree) shows after parse
                      value={
                        professionaldetails?.highestQualification?.label
                          ? {
                              label:
                                professionaldetails.highestQualification.label,
                              value:
                                professionaldetails.highestQualification.value,
                            }
                          : undefined
                      }
                      onValueChange={(e) => {
                        if (e === undefined) {
                          setprofessionalDetails({
                            ...professionaldetails,
                            highestQualification: "",
                          });
                        } else {
                          setprofessionalDetails({
                            ...professionaldetails,
                            highestQualification: e,
                          });
                          setErrors({ ...errors, highestQualification: "" });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!professionaldetails.highestQualification) {
                              setErrors({
                                ...errors,
                                highestQualification:
                                  ErrorMessage.PROVIDE_QUALIFICATION,
                              });
                            } else {
                              setErrors({
                                ...errors,
                                highestQualification: "",
                              });
                              handleUpdate(
                                "qualification",
                                professionaldetails.highestQualification.value
                              );
                              setItem(
                                "qualification",
                                professionaldetails.highestQualification.value
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("qualification");
                            setprofessionalDetails({
                              ...professionaldetails,
                              highestQualification: {
                                label:
                                  professionalDetails?.highestQualification,
                                value:
                                  professionalDetails?.highestQualification,
                              },
                            });
                            setErrors({ ...errors, highestQualification: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">
                  {errors.highestQualification}
                </span>
              </div>
            )}
          </Col>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-currentEmployer">
                <label className="form-label">
                  Current Employer<span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.currentEmployer && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(
                        professionaldetails?.currentEmployer
                      )}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("currentEmployer");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.currentEmployer) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={professionaldetails.currentEmployer}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setprofessionalDetails({
                            ...professionaldetails,
                            currentEmployer: e.target.value,
                          });
                          setErrors({ ...errors, currentEmployer: "" });
                        } else {
                          setprofessionalDetails({
                            ...professionaldetails,
                            currentEmployer: e.target.value,
                          });
                          setErrors({
                            ...errors,
                            currentEmployer:
                              ErrorMessage.PROVIDE_CURRENT_EMPLOYER,
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        {" "}
                        <ProfileSaveButton
                          onClick={() => {
                            if (!professionaldetails.currentEmployer.trim()) {
                              setErrors({
                                ...errors,
                                currentEmployer:
                                  ErrorMessage.PROVIDE_CURRENT_EMPLOYER,
                              });
                            } else {
                              setErrors({ ...errors, currentEmployer: "" });
                              handleUpdate(
                                "currentEmployer",
                                professionaldetails.currentEmployer
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("currentEmployer");
                            setprofessionalDetails({
                              ...professionaldetails,
                              currentEmployer:
                                professionalDetails.currentEmployer,
                            });
                            setErrors({ ...errors, currentEmployer: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.currentEmployer}</span>
              </div>
            )}
          </Col>

          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-totalExperiance">
                <label className="form-label">
                  Total Experience(in years)
                  <span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.totalExperiance && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(
                        professionaldetails?.totalExprience
                      )}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("totalExperiance");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.totalExperiance) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control no-spinners"
                      value={professionaldetails.totalExprience || ""}
                      min="1" // HTML5 attribute to set minimum value
                      onKeyDown={(evt) => {
                        if (evt.keyCode === 38 || evt.keyCode === 40) {
                          evt.preventDefault(); // prevent default behavior of arrow keys
                        }
                        ["e", "E", "+", "-"].includes(evt.key) &&
                          evt.preventDefault();
                      }}
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(
                            0,
                            e.target.maxLength
                          );
                      }}
                      maxlength={4}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Check specifically for "0" as the entire value
                        if (value === "0") {
                          setprofessionalDetails({
                            ...professionaldetails,
                            totalExprience: "",
                          });
                          setErrors({
                            ...errors,
                            totalExperience: "Experience cannot be zero",
                          });
                          return;
                        }

                        if (value !== "") {
                          if (
                            professionaldetails.relevantExperience !== "" &&
                            Number(value) <
                              professionaldetails.relevantExperience
                          ) {
                            setErrors({
                              ...errors,
                              totalExperience:
                                ErrorMessage.PROVIDE_VALID_TOTAL_EXPERIENCE,
                            });
                          } else {
                            setErrors({ ...errors, totalExperience: "" });
                          }
                          setprofessionalDetails({
                            ...professionaldetails,
                            totalExprience: value,
                          });
                        } else {
                          setprofessionalDetails({
                            ...professionaldetails,
                            totalExprience: value,
                          });
                          setErrors({
                            ...errors,
                            totalExperience:
                              ErrorMessage.PROVIDE_TOTAL_EXPERIENCE,
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        {" "}
                        <ProfileSaveButton
                          onClick={() => {
                            if (
                              professionaldetails.totalExprience ===
                                undefined ||
                              !professionaldetails.totalExprience.trim()
                            ) {
                              setErrors({
                                ...errors,
                                totalExperience:
                                  ErrorMessage.PROVIDE_TOTAL_EXPERIENCE,
                              });
                            } else {
                              if (
                                professionaldetails.relevantExperience !== "" &&
                                Number(professionaldetails.totalExprience) <
                                  Number(professionaldetails.relevantExperience)
                              ) {
                                setErrors({
                                  ...errors,
                                  totalExperience:
                                    ErrorMessage.PROVIDE_VALID_TOTAL_EXPERIENCE,
                                });
                              } else {
                                setErrors({
                                  ...errors,
                                  totalExperience: "",
                                });
                                handleUpdate(
                                  "totalExperiance",
                                  professionaldetails.totalExprience
                                );
                              }
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("totalExperiance");
                            setprofessionalDetails({
                              ...professionaldetails,
                              totalExprience:
                                professionalDetails.totalExprience,
                            });
                            setErrors({ ...errors, totalExperience: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.totalExperience}</span>
              </div>
            )}
          </Col>
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">
                    Relevant Experience(in years)
                  </label>

                  {!isGuest && !showInput.relevantExperiance && (
                    <div className="edit-profile-input">
                      <h6
                        className="mt-1 text-title cursor-pencil"
                        onClick={() => handleShowInput("relevantExperiance")}
                      >
                        {profileDataValidation(
                          professionaldetails?.relevantExperience
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("relevantExperiance");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.relevantExperiance) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control no-spinners"
                        value={professionaldetails.relevantExperience}
                        onKeyDown={(evt) => {
                          if (evt.keyCode === 38 || evt.keyCode === 40) {
                            evt.preventDefault(); // prevent default behavior of arrow keys
                          }
                          ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault();
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxlength={4}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            if (
                              professionaldetails.totalExprience !== "" &&
                              Number(e.target.value) >
                                professionaldetails.totalExprience
                            ) {
                              setErrors({
                                ...errors,
                                relevantExperience:
                                  ErrorMessage.PROVIDE_VALID_RELEVENT_EXPERIENCE,
                              });
                            } else {
                              setErrors({ ...errors, relevantExperience: "" });
                            }
                            setprofessionalDetails({
                              ...professionaldetails,
                              relevantExperience: e.target.value,
                            });
                          } else {
                            setprofessionalDetails({
                              ...professionaldetails,
                              relevantExperience: e.target.value,
                            });
                            setErrors({
                              ...errors,
                              relevantExperience:
                                ErrorMessage.PROVIDE_RELEVENT_EXPERIENCE,
                            });
                          }
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              if (
                                professionaldetails.relevantExperience ===
                                  undefined ||
                                !professionaldetails.relevantExperience.trim()
                              ) {
                                setErrors({
                                  ...errors,
                                  relevantExperience:
                                    ErrorMessage.PROVIDE_RELEVENT_EXPERIENCE,
                                });
                              } else {
                                if (
                                  professionaldetails.totalExprience !== "" &&
                                  Number(
                                    professionaldetails.relevantExperience
                                  ) > Number(professionaldetails.totalExprience)
                                ) {
                                  setErrors({
                                    ...errors,
                                    relevantExperience:
                                      ErrorMessage.PROVIDE_VALID_RELEVENT_EXPERIENCE,
                                  });
                                } else {
                                  setErrors({
                                    ...errors,
                                    relevantExperience: "",
                                  });
                                  handleUpdate(
                                    "relevantExperiance",
                                    professionaldetails.relevantExperience
                                  );
                                }
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("relevantExperiance");
                              setprofessionalDetails({
                                ...professionaldetails,
                                relevantExperience:
                                  professionalDetails.relevantExperience,
                              });
                              setErrors({ ...errors, relevantExperience: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">
                    {errors.relevantExperience}
                  </span>
                </div>
              )}
            </Col>
          )}
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-currentSalary">
                <label className="form-label">
                  Current Salary(in LPA)<span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.currentSalary && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(
                        professionaldetails?.currentSalary
                      )}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("currentSalary");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.currentSalary) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control no-spinners"
                      value={professionaldetails.currentSalary}
                      onKeyDown={(evt) => {
                        if (evt.keyCode === 38 || evt.keyCode === 40) {
                          evt.preventDefault(); // prevent default behavior of arrow keys
                        }
                        ["e", "E", "+", "-"].includes(evt.key) &&
                          evt.preventDefault();
                      }}
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(
                            0,
                            e.target.maxLength
                          );
                      }}
                      maxlength={4}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setprofessionalDetails({
                            ...professionaldetails,
                            currentSalary: e.target.value,
                          });
                          setErrors({ ...errors, currentSalary: "" });
                        } else {
                          setprofessionalDetails({
                            ...professionaldetails,
                            currentSalary: e.target.value,
                          });
                          setErrors({
                            ...errors,
                            currentSalary: ErrorMessage.PROVIDE_CURRENT_SALARY,
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        {" "}
                        <ProfileSaveButton
                          onClick={() => {
                            if (
                              !professionaldetails.currentSalary.trim() ||
                              professionaldetails.currentSalary === undefined
                            ) {
                              setErrors({
                                ...errors,
                                currentSalary:
                                  ErrorMessage.PROVIDE_CURRENT_SALARY,
                              });
                            } else {
                              setErrors({ ...errors, currentSalary: "" });
                              handleUpdate(
                                "currentSalary",
                                professionaldetails.currentSalary
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("currentSalary");
                            setprofessionalDetails({
                              ...professionaldetails,
                              currentSalary: professionalDetails.currentSalary,
                            });
                            setErrors({ ...errors, currentSalary: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.currentSalary}</span>
              </div>
            )}
          </Col>
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Expected Salary(in LPA)</label>
                  {!isGuest && !showInput.expectedSalary && (
                    <div className="edit-profile-input">
                      <h6
                        className="mt-1 text-title cursor-pencil"
                        onClick={() => handleShowInput("expectedSalary")}
                      >
                        {profileDataValidation(
                          professionaldetails?.expectedSalary
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("expectedSalary");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.expectedSalary) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control no-spinners"
                        value={professionaldetails.expectedSalary}
                        onKeyDown={(evt) => {
                          if (evt.keyCode === 38 || evt.keyCode === 40) {
                            evt.preventDefault(); // prevent default behavior of arrow keys
                          }
                          ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault();
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxlength={4}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setprofessionalDetails({
                              ...professionaldetails,
                              expectedSalary: e.target.value,
                            });
                            setErrors({ ...errors, expectedSalary: "" });
                          } else {
                            setprofessionalDetails({
                              ...professionaldetails,
                              expectedSalary: e.target.value,
                            });
                            setErrors({
                              ...errors,
                              expectedSalary:
                                ErrorMessage.PROVIDE_EXPECTED_SALARY,
                            });
                          }
                        }}
                      />
                      {!isGuest && (
                        <>
                          {" "}
                          <ProfileSaveButton
                            onClick={() => {
                              if (
                                !professionaldetails.expectedSalary.trim() ||
                                professionaldetails.expectedSalary === undefined
                              ) {
                                setErrors({
                                  ...errors,
                                  expectedSalary:
                                    ErrorMessage.PROVIDE_EXPECTED_SALARY,
                                });
                              } else {
                                setErrors({ ...errors, expectedSalary: "" });
                                handleUpdate(
                                  "expectedSalary",
                                  professionaldetails.expectedSalary
                                );
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("expectedSalary");
                              setprofessionalDetails({
                                ...professionaldetails,
                                expectedSalary:
                                  professionalDetails.expectedSalary,
                              });
                              setErrors({ ...errors, expectedSalary: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}{" "}
                  <span className="text-error">{errors.expectedSalary}</span>
                </div>
              )}
            </Col>
          )}

          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Current Designation</label>

                  {!isGuest && !showInput.currentDesignation && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(
                          professionaldetails?.currentDesignation
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("currentDesignation");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.currentDesignation) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={professionaldetails.currentDesignation}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setprofessionalDetails({
                              ...professionaldetails,
                              currentDesignation: e.target.value,
                            });
                            setErrors({ ...errors, currentDesignation: "" });
                          } else {
                            setprofessionalDetails({
                              ...professionaldetails,
                              currentDesignation: e.target.value,
                            });
                            setErrors({
                              ...errors,
                              currentDesignation:
                                ErrorMessage.PROVIDE_CURRENT_DESIGNATION,
                            });
                          }
                        }}
                      />
                      {!isGuest && (
                        <>
                          {" "}
                          <ProfileSaveButton
                            onClick={() => {
                              if (
                                !professionaldetails.currentDesignation.trim()
                              ) {
                                setErrors({
                                  ...errors,
                                  currentDesignation:
                                    ErrorMessage.PROVIDE_CURRENT_DESIGNATION,
                                });
                              } else {
                                setErrors({
                                  ...errors,
                                  currentDesignation: "",
                                });
                                handleUpdate(
                                  "currentDesignation",
                                  professionaldetails.currentDesignation
                                );
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("currentDesignation");
                              setprofessionalDetails({
                                ...professionaldetails,
                                currentDesignation:
                                  professionalDetails.currentDesignation,
                              });
                              setErrors({ ...errors, currentDesignation: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">
                    {errors.currentDesignation}
                  </span>
                </div>
              )}
            </Col>
          )}
          <Col md={8} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-skillSet">
                <label className="form-label">Skill Set<span className="text-danger">*</span></label>
                {!isGuest && !showInput.skillSet && (
                  <div className="edit-profile-input">
                    <span className="edit-skills">
                      {professionaldetails?.skillSet?.length > 0
                        ? professionaldetails?.skillSet.map((skill) => (
                            <Badge
                              bg="secondary"
                              className="badge-custom me-2 cursor-pencil"
                              onClick={() => handleShowInput("skillSet")}
                            >
                              {skill?.label ?? ""}
                            </Badge>
                          ))
                        : !showInput.skillSet && (
                            <h6
                              className="mt-1 text-title cursor-pencil"
                              onClick={() => handleShowInput("skillSet")}
                            >
                              - -
                            </h6>
                          )}
                    </span>
                    {!showInput.skillSet && (
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("skillSet");
                        }}
                      />
                    )}
                  </div>
                )}

                {(isGuest || showInput.skillSet) && (
                  <div className="edit-inline-action">
                    <MultiSelectComponent
                      placeholder="Select Skill Set"
                      options={skillSetOptions}
                      values={professionaldetails?.skillSet?.filter(
                        (skill) => skill?.label !== undefined
                      )}
                      onValuesChange={(e) => {
                        if (e === undefined) return;
                        else {
                          if (e.length > 0) {
                            setprofessionalDetails({
                              ...professionaldetails,
                              skillSet: e,
                            });

                            skillSetOptions?.forEach((item) => {
                              if (
                                item?.value?.trim() === "" &&
                                item?.label?.trim() !== ""
                              ) {
                                dispatch(
                                  addSkillsMaster({
                                    skill: item.label,
                                  })
                                );
                                // setSkillSetOption(e);
                              }
                            });
                            setErrors({ ...errors, skillSet: "" });
                          } else {
                            setprofessionalDetails({
                              ...professionaldetails,
                              skillSet: e,
                            });

                            setErrors({
                              ...errors,
                              skillSet: ErrorMessage.PROVIDE_SKILL_SET,
                            });
                          }
                        }
                      }}
                      onSearchChange={(value) => {
                        if (value && value.trim() !== "") {
                          const lowercasedValue = value.toLowerCase();
                          const isExistingOption = skillSetOptions?.some(
                            (option) =>
                              option.label.toLowerCase() === lowercasedValue
                          );
                          clearTimeout(typingTimer);
                          if (!isExistingOption) {
                            typingTimer = setTimeout(() => {
                              let updatedOptions = skillSetOptions;
                              updatedOptions[updatedOptions.length - 1].label =
                                value;

                              setSkillSetOptions([...updatedOptions]);
                            }, 1000);
                            return;
                          }
                        }
                      }}
                      onBlur={() => {
                        let list = [];
                        skillSetList?.map((item) => {
                          return list.push({
                            label: item?.skill,
                            value: item?._id,
                          });
                        });
                        setSkillSetOptions([
                          ...list,
                          {
                            label: "",
                            value: "",
                          },
                        ]);
                      }}
                      onRemoveItem={(item) => {
                        const dataval = (
                          professionaldetails.skillSet || []
                        ).filter((d) => item.value !== d?.value);

                        setprofessionalDetails({
                          ...professionaldetails,
                          skillSet: dataval,
                        });
                      }}
                    />

                    {!isGuest && (
                      <>
                        {" "}
                        <ProfileSaveButton
                          onClick={() => {
                            if (professionaldetails.skillSet.length === 0) {
                              setErrors({
                                ...errors,
                                skillSet: ErrorMessage.PROVIDE_SKILL_SET,
                              });
                            } else {
                              setErrors({
                                ...errors,
                                skillSet: "",
                              });
                              handleUpdate(
                                "skillSet",
                                professionaldetails.skillSet.map(
                                  (skill) => skill.value
                                )
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            const dataval = professionalDetails?.skillSet?.map(
                              (skill) => {
                                return { label: skill.skill, value: skill._id };
                              }
                            );
                            handleShowInput("skillSet");
                            setprofessionalDetails({
                              ...professionaldetails,
                              skillSet: dataval,
                            });
                            setErrors({ ...errors, skillSet: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.skillSet}</span>
              </div>
            )}
          </Col>
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Expected Joining Date</label>
                  {!isGuest && !showInput.joiningDate && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(
                          professionalDetails?.expectedjoiningDate
                            ? moment(
                                professionalDetails?.expectedjoiningDate
                              ).format("DD-MMM-YYYY")
                            : ""
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("joiningDate");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.joiningDate) && (
                    <div className="edit-inline-action">
                      <DatePicker
                        placeholderText="mm/dd/yyyy"
                        selected={
                          new Date(professionaldetails?.expectedjoiningDate) ||
                          new Date()
                        }
                        onChange={(date) => {
                          setprofessionalDetails({
                            ...professionaldetails,
                            expectedjoiningDate: date.setUTCHours(0, 0, 0, 0),
                          });
                        }}
                        showYearDropdown
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={70}
                        scrollableYearDropdown
                        className="form-control w-100"
                        minDate={moment().toDate()}
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              handleUpdate(
                                "joiningDate",
                                professionaldetails.expectedjoiningDate
                              );
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("joiningDate");
                              setprofessionalDetails({
                                ...professionaldetails,
                                expectedjoiningDate:
                                  professionalDetails.expectedjoiningDate,
                              });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Additional Info</label>
                  {!isGuest && !showInput.additionalInfo && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(
                          professionaldetails?.additionalInfo
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("additionalInfo");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.additionalInfo) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        as={"textarea"}
                        type="text"
                        value={professionaldetails.additionalInfo}
                        onChange={(e) => {
                          setprofessionalDetails({
                            ...professionaldetails,
                            additionalInfo: e.target.value,
                          });
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              handleUpdate(
                                "additionalInfo",
                                professionaldetails.additionalInfo
                              );
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("additionalInfo");
                              setprofessionalDetails({
                                ...professionaldetails,
                                additionalInfo:
                                  professionalDetails.additionalInfo,
                              });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}

          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">
                    Candidate Website(Portfolio)
                  </label>
                  {!isGuest && !showInput.website && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(professionaldetails?.portfolio)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("website");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.website) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={professionaldetails.portfolio}
                        onChange={(e) => {
                          setprofessionalDetails({
                            ...professionaldetails,
                            portfolio: e.target.value,
                          });
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              handleUpdate(
                                "website",
                                professionaldetails.portfolio
                              );
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("website");
                              setprofessionalDetails({
                                ...professionaldetails,
                                portfolio: professionalDetails.portfolio,
                              });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Skype ID</label>
                  {!isGuest && !showInput.skypeId && (
                    <div className="edit-profile-input">
                      <h6
                        className="mt-1 text-title cursor-pencil"
                        onClick={() => handleShowInput("skypeId")}
                      >
                        {profileDataValidation(professionaldetails?.skypeId)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("skypeId");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.skypeId) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={professionaldetails.skypeId}
                        onChange={(e) => {
                          setprofessionalDetails({
                            ...professionaldetails,
                            skypeId: e.target.value,
                          });
                        }}
                      />
                      {!isGuest && (
                        <>
                          {" "}
                          <ProfileSaveButton
                            onClick={() => {
                              handleUpdate(
                                "skypeId",
                                professionaldetails.skypeId
                              );
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("skypeId");
                              setprofessionalDetails({
                                ...professionaldetails,
                                skypeId: professionalDetails.skypeId,
                              });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default ProfessionalDetail;
